import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';

import { 
  Search, 
  ShoppingCart, 
  User, 
  Menu, 
  X, 
  Heart, 
  Star, 
  Filter,
  Grid3X3,
  List,
  MessageCircle,
  Send,
  Minimize2,
  Phone,
  Mail,
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  ChevronLeft,
  ChevronRight,
  Play,
  Shield,
  Truck,
  RotateCcw,
  Award,
  Eye,
  Share2,
  Gift,
  Zap,
  Crown,
  Sparkles
} from 'lucide-react';

const EcommerceInterface = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([
    { id: 1, text: "Welcome to LUXE! I'm Sofia, your personal shopping assistant. How can I help you discover something extraordinary today?", isBot: true }
  ]);
  const [chatInput, setChatInput] = useState('');
  const [viewMode, setViewMode] = useState('grid');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [wishlist, setWishlist] = useState(new Set());

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const heroSlides = [
    {
      id: 1,
      title: "PREMIUM COLLECTION",
      subtitle: "2025 EDITION",
      description: "Discover extraordinary products crafted for the discerning professional",
      background: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1920&h=1080&fit=crop&q=80",
      cta: "Explore Collection"
    },
    {
      id: 2,
      title: "EXCLUSIVE WATCHES",
      subtitle: "LIMITED SERIES",
      description: "Handcrafted timepieces that define elegance and precision",
      background: "https://images.unsplash.com/photo-1539874754764-5a96559165b0?w=1920&h=1080&fit=crop&q=80",
      cta: "Shop Watches"
    },
    {
      id: 3,
      title: "TECH REVOLUTION",
      subtitle: "INNOVATION REDEFINED",
      description: "Cutting-edge technology meets sophisticated design",
      background: "https://images.unsplash.com/photo-1468495244123-6c6c332eeece?w=1920&h=1080&fit=crop&q=80",
      cta: "Discover Tech"
    }
  ];

  const products = [
    {
      id: 1,
      name: "MacBook Pro 16\" M3 Max",
      price: 3999.99,
      originalPrice: 4299.99,
      rating: 4.9,
      reviews: 2847,
      image: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=500&h=500&fit=crop&q=80",
      secondaryImage: "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=500&h=500&fit=crop&q=80",
      category: "Electronics",
      badge: "Bestseller",
      description: "The most powerful MacBook Pro ever with M3 Max chip",
      features: ["M3 Max Chip", "64GB RAM", "2TB SSD", "Liquid Retina XDR"],
      inStock: true,
      fastShipping: true
    },
    {
      id: 2,
      name: "Sony α7R V Mirrorless Camera",
      price: 3899.99,
      originalPrice: 4199.99,
      rating: 4.8,
      reviews: 891,
      image: "https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?w=500&h=500&fit=crop&q=80",
      secondaryImage: "https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=500&h=500&fit=crop&q=80",
      category: "Photography",
      badge: "Professional",
      description: "61MP full-frame sensor with advanced AI processing",
      features: ["61MP Sensor", "8K Video", "AI Autofocus", "Weather Sealed"],
      inStock: true,
      fastShipping: false
    },
    {
      id: 3,
      name: "Rolex Submariner Date",
      price: 13250.00,
      rating: 4.9,
      reviews: 156,
      image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&h=500&fit=crop&q=80",
      secondaryImage: "https://images.unsplash.com/photo-1594534475808-b18fc33b045e?w=500&h=500&fit=crop&q=80",
      category: "Watches",
      badge: "Luxury",
      description: "Iconic diving watch with Oystersteel construction",
      features: ["Automatic Movement", "300m Water Resistance", "Cerachrom Bezel", "Oystersteel"],
      inStock: false,
      fastShipping: false
    },
    {
      id: 4,
      name: "Apple Watch Ultra 2",
      price: 799.99,
      rating: 4.7,
      reviews: 3241,
      image: "https://images.unsplash.com/photo-1575311373937-040b8e1fd5b6?w=500&h=500&fit=crop&q=80",
      secondaryImage: "https://images.unsplash.com/photo-1510017098667-27dfe7d03ba3?w=500&h=500&fit=crop&q=80",
      category: "Fitness",
      badge: "New",
      description: "The most rugged and capable Apple Watch yet",
      features: ["Titanium Case", "100m Water Resistance", "Precision GPS", "Action Button"],
      inStock: true,
      fastShipping: true
    },
    {
      id: 5,
      name: "Bang & Olufsen Beoplay H95",
      price: 800.00,
      originalPrice: 900.00,
      rating: 4.6,
      reviews: 428,
      image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&h=500&fit=crop&q=80",
      secondaryImage: "https://images.unsplash.com/photo-1484704849700-f032a568e944?w=500&h=500&fit=crop&q=80",
      category: "Audio",
      badge: "Premium",
      description: "Flagship noise-cancelling headphones with adaptive ANC",
      features: ["Adaptive ANC", "38-hour Battery", "Premium Materials", "Wireless Charging"],
      inStock: true,
      fastShipping: true
    },
    {
      id: 6,
      name: "Louis Vuitton Keepall 55",
      price: 2200.00,
      rating: 4.8,
      reviews: 89,
      image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=500&h=500&fit=crop&q=80",
      secondaryImage: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=500&h=500&fit=crop&q=80",
      category: "Fashion",
      badge: "Iconic",
      description: "Timeless travel bag in signature Monogram canvas",
      features: ["Monogram Canvas", "Leather Trim", "Handcrafted", "Travel Size"],
      inStock: true,
      fastShipping: false
    }
  ];

  const categories = ['All', 'Electronics', 'Photography', 'Watches', 'Fitness', 'Audio', 'Fashion'];

  const filteredProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  const handleChatSubmit = (e) => {
  e.preventDefault();

  if (chatInput.trim()) {
    const newMessage = { id: Date.now(), text: chatInput, isBot: false };
    setChatMessages([...chatMessages, newMessage]);

    // Send email using EmailJS
    const templateParams = {
      message: chatInput,
      subject: "LUXE Abiloop - Live chat message",
      user_name:  'Guest',
      user_email:'not_provided@example.com',
    };

    emailjs.send(
       'service_vk6eiym',     // e.g. service_xxxxx
        'template_4pwjk5r',    // e.g. template_yyyyy
      templateParams,
      'P9DB1kB37lbSYsdbr'        
    )
    .then((response) => {
      alert('Message sent successfully!');
    })
    .catch((error) => {
      alert(' Failed to send message. Please try again.');
      //console.error('EmailJS Error:', error);
    });

    // Clear input
    setChatInput('');

    // Bot reply after delay
    setTimeout(() => {
      const responses = [
        "I'd be happy to help you find the perfect product! What specific features are you looking for?",
        "Great question! Let me connect you with our product specialist who can provide detailed information.",
        "I can help you with that! Would you like me to show you our most popular items in that category?",
        "Thank you for reaching out! Our premium collection has some amazing options. What's your budget range?",
        "Excellent choice! That product is currently trending. Would you like to see similar premium alternatives?"
      ];
      const randomResponse = responses[Math.floor(Math.random() * responses.length)];
      const botResponse = { 
        id: Date.now() + 1, 
        text: randomResponse, 
        isBot: true 
      };
      setChatMessages(prev => [...prev, botResponse]);
    }, 1000);
  }
};


  const toggleWishlist = (productId) => {
    const newWishlist = new Set(wishlist);
    if (newWishlist.has(productId)) {
      newWishlist.delete(productId);
    } else {
      newWishlist.add(productId);
    }
    setWishlist(newWishlist);
  };

  const getBadgeColor = (badge) => {
    const colors = {
      'Bestseller': 'bg-green-500',
      'Professional': 'bg-blue-500',
      'Luxury': 'bg-purple-500',
      'New': 'bg-red-500',
      'Premium': 'bg-yellow-500',
      'Iconic': 'bg-pink-500'
    };
    return colors[badge] || 'bg-gray-500';
  };

  return (
    <div className="min-h-screen bg-white text-black">
      {/* Navigation Bar */}
      <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-black/80'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center">
              <Crown className="h-8 w-8 text-yellow-400 mr-2" />
              <h1 className="text-2xl font-bold text-white">LUXE</h1>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="#" className="hover:text-yellow-400 px-3 py-2 text-sm font-medium transition-colors text-white">Home</a>
                <a href="#" className="hover:text-yellow-400 px-3 py-2 text-sm font-medium transition-colors text-white">Categories</a>
                <a href="#" className="hover:text-yellow-400 px-3 py-2 text-sm font-medium transition-colors text-white">Products</a>
                <a href="#" className="hover:text-yellow-400 px-3 py-2 text-sm font-medium transition-colors text-white">About</a>
                <a href="#" className="hover:text-yellow-400 px-3 py-2 text-sm font-medium transition-colors text-white">Contact</a>
              </div>
            </div>

            {/* Search Bar */}
            <div className="hidden md:flex flex-1 max-w-md mx-8">
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Search luxury products..."
                  className="w-full bg-white/10 backdrop-blur-md text-white placeholder-gray-300 pl-10 pr-4 py-2 rounded-full border border-white/20 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:bg-white/20 transition-all"
                />
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-300" />
              </div>
            </div>

            {/* Auth & Cart */}
            <div className="hidden md:flex items-center space-x-4">
              <button className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-4 py-2 rounded-full hover:from-yellow-500 hover:to-yellow-600 transition-all text-sm font-medium">
                Login
              </button>
              <button className="border border-white/30 text-white px-4 py-2 rounded-full hover:bg-white hover:text-black transition-all text-sm font-medium backdrop-blur-md">
                Sign Up
              </button>
              <button className="relative p-2 hover:bg-white/10 rounded-full transition-colors">
                <Heart className="h-5 w-5 text-white" />
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center font-medium">2</span>
              </button>
              <button className="relative p-2 hover:bg-white/10 rounded-full transition-colors">
                <ShoppingCart className="h-5 w-5 text-white" />
                <span className="absolute -top-1 -right-1 bg-yellow-400 text-black text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">3</span>
              </button>
              <button className="p-2 hover:bg-white/10 rounded-full transition-colors">
                <User className="h-5 w-5 text-white" />
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 rounded-lg hover:bg-white/10 transition-colors"
              >
                {isMobileMenuOpen ? <X className="h-6 w-6 text-white" /> : <Menu className="h-6 w-6 text-white" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <div className="mb-4 px-3">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search luxury products..."
                    className="w-full bg-white/10 text-white placeholder-gray-300 pl-10 pr-4 py-2 rounded-full border border-white/20 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                  />
                  <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-300" />
                </div>
              </div>
              <a href="#" className="block px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg text-white">Home</a>
              <a href="#" className="block px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg text-white">Categories</a>
              <a href="#" className="block px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg text-white">Products</a>
              <a href="#" className="block px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg text-white">About</a>
              <a href="#" className="block px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg text-white">Contact</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section with Carousel */}
      <section className="relative h-screen overflow-hidden">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-all duration-1000 ${
              index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
            }`}
          >
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${slide.background})` }}
            />
            <div className="absolute inset-0 bg-black/50" />
            <div className="relative h-full flex items-center justify-center text-white">
              <div className="text-center max-w-4xl px-4">
                <div className="mb-4 inline-flex items-center space-x-2 bg-yellow-400/20 backdrop-blur-md px-4 py-2 rounded-full border border-yellow-400/30">
                  <Sparkles className="h-4 w-4 text-yellow-400" />
                  <span className="text-yellow-400 font-medium">{slide.subtitle}</span>
                </div>
                <h1 className="text-6xl md:text-8xl font-bold mb-6 tracking-tight leading-none">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl mb-12 max-w-2xl mx-auto text-gray-200 leading-relaxed">
                  {slide.description}
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <button className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-8 py-4 rounded-full text-lg font-semibold hover:from-yellow-500 hover:to-yellow-600 transition-all transform hover:scale-105 shadow-2xl">
                    {slide.cta}
                  </button>
                  <button className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-black transition-all backdrop-blur-md">
                    <Play className="inline-block w-5 h-5 mr-2" />
                    Watch Story
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        
        {/* Carousel Controls */}
        <button
          onClick={() => setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
          className="absolute left-8 top-1/2 transform -translate-y-1/2 bg-white/20 backdrop-blur-md hover:bg-white/30 p-4 rounded-full transition-all"
        >
          <ChevronLeft className="h-6 w-6 text-white" />
        </button>
        <button
          onClick={() => setCurrentSlide((prev) => (prev + 1) % heroSlides.length)}
          className="absolute right-8 top-1/2 transform -translate-y-1/2 bg-white/20 backdrop-blur-md hover:bg-white/30 p-4 rounded-full transition-all"
        >
          <ChevronRight className="h-6 w-6 text-white" />
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentSlide ? 'bg-yellow-400 scale-125' : 'bg-white/50 hover:bg-white/70'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Trust Badges */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <Shield className="h-8 w-8 text-green-600 mx-auto mb-2" />
              <h3 className="font-semibold text-gray-900">Secure Payment</h3>
              <p className="text-sm text-gray-600">256-bit SSL encryption</p>
            </div>
            <div className="text-center">
              <Truck className="h-8 w-8 text-blue-600 mx-auto mb-2" />
              <h3 className="font-semibold text-gray-900">Free Shipping</h3>
              <p className="text-sm text-gray-600">On orders over $500</p>
            </div>
            <div className="text-center">
              <RotateCcw className="h-8 w-8 text-purple-600 mx-auto mb-2" />
              <h3 className="font-semibold text-gray-900">Easy Returns</h3>
              <p className="text-sm text-gray-600">30-day return policy</p>
            </div>
            <div className="text-center">
              <Award className="h-8 w-8 text-yellow-600 mx-auto mb-2" />
              <h3 className="font-semibold text-gray-900">Premium Quality</h3>
              <p className="text-sm text-gray-600">Authenticity guaranteed</p>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white sticky top-16 z-40 border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full font-medium transition-all ${
                  selectedCategory === category
                    ? 'bg-black text-white shadow-lg transform scale-105'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:scale-105'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Filter and View Controls */}
      <section className="bg-gray-50 border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-4">
              <button className="flex items-center space-x-2 bg-gradient-to-r from-gray-900 to-black text-white px-6 py-3 rounded-full hover:shadow-lg transition-all">
                <Filter className="h-4 w-4" />
                <span>Advanced Filters</span>
              </button>
              <select className="border border-gray-300 rounded-full px-6 py-3 focus:outline-none focus:ring-2 focus:ring-black bg-white shadow-sm">
                <option>All Categories</option>
                <option>Electronics</option>
                <option>Photography</option>
                <option>Watches</option>
                <option>Fitness</option>
                <option>Audio</option>
                <option>Fashion</option>
              </select>
            </div>
            <div className="flex items-center space-x-6">
              <span className="text-gray-600 font-medium">Sort by:</span>
              <select className="border border-gray-300 rounded-full px-6 py-3 focus:outline-none focus:ring-2 focus:ring-black bg-white shadow-sm">
                <option>Featured</option>
                <option>Price: Low to High</option>
                <option>Price: High to Low</option>
                <option>Customer Rating</option>
                <option>Newest First</option>
              </select>
              <div className="flex border border-gray-300 rounded-full overflow-hidden shadow-sm">
                <button
                  onClick={() => setViewMode('grid')}
                  className={`p-3 ${viewMode === 'grid' ? 'bg-black text-white' : 'bg-white hover:bg-gray-50'} transition-colors`}
                >
                  <Grid3X3 className="h-4 w-4" />
                </button>
                <button
                  onClick={() => setViewMode('list')}
                  className={`p-3 ${viewMode === 'list' ? 'bg-black text-white' : 'bg-white hover:bg-gray-50'} transition-colors`}
                >
                  <List className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`grid gap-8 ${viewMode === 'grid' ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1'}`}>
            {filteredProducts.map((product) => (
              <div 
                key={product.id} 
                className={`group bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 ${viewMode === 'list' ? 'flex' : ''}`}
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <div className={`relative ${viewMode === 'list' ? 'w-80 flex-shrink-0' : ''}`}>
                  <div className="relative overflow-hidden bg-gray-100">
                    <img
                      src={hoveredProduct === product.id && product.secondaryImage ? product.secondaryImage : product.image}
                      alt={product.name}
                      className={`w-full object-cover transition-all duration-500 ${viewMode === 'list' ? 'h-64' : 'h-80'} ${hoveredProduct === product.id ? 'scale-110' : 'scale-100'}`}
                    />
                    
                    {/* Overlay Actions */}
                    <div className={`absolute inset-0 bg-black/20 transition-opacity duration-300 ${hoveredProduct === product.id ? 'opacity-100' : 'opacity-0'}`}>
                      <div className="absolute top-4 right-4 flex flex-col space-y-2">
                        <button 
                          onClick={() => toggleWishlist(product.id)}
                          className={`p-3 rounded-full shadow-lg transition-all ${wishlist.has(product.id) ? 'bg-red-500 text-white' : 'bg-white text-gray-700 hover:bg-red-500 hover:text-white'}`}
                        >
                          <Heart className={`h-4 w-4 ${wishlist.has(product.id) ? 'fill-current' : ''}`} />
                        </button>
                        <button className="p-3 bg-white text-gray-700 rounded-full shadow-lg hover:bg-gray-100 transition-all">
                          <Eye className="h-4 w-4" />
                        </button>
                        <button className="p-3 bg-white text-gray-700 rounded-full shadow-lg hover:bg-gray-100 transition-all">
                          <Share2 className="h-4 w-4" />
                        </button>
                      </div>
                      
                      <div className={`absolute bottom-4 left-4 right-4 transform transition-all duration-300 ${hoveredProduct === product.id ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
                        <button className="w-full bg-white text-black py-3 rounded-full font-semibold hover:bg-gray-100 transition-all shadow-lg">
                          Quick Add to Cart
                        </button>
                      </div>
                    </div>

                    {/* Badges */}
                    <div className="absolute top-4 left-4 flex flex-col space-y-2">
                      {product.badge && (
                        <span className={`${getBadgeColor(product.badge)} text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg`}>
                          {product.badge}
                        </span>
                      )}
                      {product.originalPrice && (
                        <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg">
                          {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% OFF
                        </span>
                      )}
                      {!product.inStock && (
                        <span className="bg-gray-500 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg">
                          Out of Stock
                        </span>
                      )}
                      {product.fastShipping && (
                        <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg flex items-center">
                          <Zap className="h-3 w-3 mr-1" />
                          Fast Shipping
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className={`p-6 ${viewMode === 'list' ? 'flex-1' : ''}`}>
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-sm text-gray-500 font-medium uppercase tracking-wide">{product.category}</span>
                    <div className="flex items-center space-x-1">
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <Star key={i} className={`h-4 w-4 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />
                        ))}
                      </div>
                      <span className="text-sm font-medium text-gray-900">{product.rating}</span>
                      <span className="text-sm text-gray-500">({product.reviews.toLocaleString()})</span>
                    </div>
                  </div>
                  
                  <h3 className="text-xl font-bold mb-2 group-hover:text-gray-600 transition-colors leading-snug">{product.name}</h3>
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">{product.description}</p>
                  
                  {/* Features */}
                  <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                      {product.features.slice(0, 3).map((feature, index) => (
                        <span key={index} className="bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs font-medium">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="mb-6">
                    <div className="flex items-center space-x-3">
                      <span className="text-3xl font-bold text-gray-900">${product.price.toLocaleString()}</span>
                      {product.originalPrice && (
                        <span className="text-xl text-gray-500 line-through">${product.originalPrice.toLocaleString()}</span>
                      )}
                    </div>
                    {product.originalPrice && (
                      <p className="text-sm text-green-600 font-medium mt-1">
                        You save ${(product.originalPrice - product.price).toLocaleString()}
                      </p>
                    )}
                  </div>
                  
                  <div className={`space-y-3 ${viewMode === 'list' ? 'flex flex-col justify-end' : ''}`}>
                    <button 
                      className={`w-full py-4 rounded-full font-semibold transition-all transform hover:scale-105 shadow-lg ${
                        product.inStock 
                          ? 'bg-gradient-to-r from-gray-900 to-black text-white hover:shadow-xl' 
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}
                      disabled={!product.inStock}
                    >
                      {product.inStock ? 'Add to Cart' : 'Out of Stock'}
                    </button>
                    <div className="flex space-x-3">
                      <button className="flex-1 border-2 border-gray-900 text-gray-900 py-3 rounded-full hover:bg-gray-900 hover:text-white transition-all font-medium">
                        Quick View
                      </button>
                      <button className="flex-1 border-2 border-yellow-400 text-yellow-600 py-3 rounded-full hover:bg-yellow-400 hover:text-white transition-all font-medium flex items-center justify-center">
                        <Gift className="h-4 w-4 mr-2" />
                        Gift
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Load More Button */}
          <div className="text-center mt-12">
            <button className="bg-gradient-to-r from-gray-900 to-black text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl transition-all transform hover:scale-105">
              Load More Products
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 to-black text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <Sparkles className="h-12 w-12 text-yellow-400 mx-auto mb-4" />
            <h2 className="text-4xl font-bold mb-4">Stay in the Loop</h2>
            <p className="text-xl text-gray-300">Get exclusive access to new arrivals, special offers, and luxury insights</p>
          </div>
          <div className="flex flex-col sm:flex-row max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-6 py-4 rounded-l-full sm:rounded-r-none rounded-r-full bg-white/10 backdrop-blur-md border border-white/20 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
            <button className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-8 py-4 rounded-r-full sm:rounded-l-none rounded-l-full font-semibold hover:from-yellow-500 hover:to-yellow-600 transition-all transform hover:scale-105 mt-4 sm:mt-0">
              Subscribe
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div>
              <div className="flex items-center mb-6">
                <Crown className="h-8 w-8 text-yellow-400 mr-2" />
                <h3 className="text-2xl font-bold">LUXE</h3>
              </div>
              <p className="text-gray-400 mb-6 leading-relaxed">Premium products for the modern professional. Quality, style, and innovation in every purchase. Experience luxury redefined.</p>
              <div className="flex space-x-4">
                <Facebook className="h-6 w-6 hover:text-yellow-400 cursor-pointer transition-colors" />
                <Twitter className="h-6 w-6 hover:text-yellow-400 cursor-pointer transition-colors" />
                <Instagram className="h-6 w-6 hover:text-yellow-400 cursor-pointer transition-colors" />
                <Linkedin className="h-6 w-6 hover:text-yellow-400 cursor-pointer transition-colors" />
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#" className="hover:text-yellow-400 transition-colors">About Us</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Contact</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Careers</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Press</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Partnerships</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-6">Customer Service</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Help Center</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Returns & Exchanges</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Shipping Info</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Size Guide</a></li>
                <li><a href="#" className="hover:text-yellow-400 transition-colors">Track Order</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-6">Contact Info</h4>
              <div className="space-y-4 text-gray-400">
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-yellow-400" />
                  <span>+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-yellow-400" />
                  <span>support@luxe.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className="h-5 w-5 text-yellow-400" />
                  <span>Fifth Avenue, New York, NY 10001</span>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-16 pt-8 text-center text-gray-400">
            <p>&copy; 2025 LUXE. All rights reserved. | Privacy Policy | Terms of Service | Cookie Policy</p>
          </div>
        </div>
      </footer>

      {/* Enhanced Chatbot */}
      {isChatbotOpen && (
        <div className="fixed bottom-4 right-4 w-96 h-[500px] bg-white border border-gray-300 rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden">
          <div className="bg-gradient-to-r from-black to-gray-800 text-white p-6 flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center">
                <span className="text-black font-bold">S</span>
              </div>
              <div>
                <h3 className="font-semibold">Sofia</h3>
                <p className="text-sm text-gray-300">Personal Shopping Assistant</p>
              </div>
            </div>
            <button
              onClick={() => setIsChatbotOpen(false)}
              className="hover:bg-white/10 p-2 rounded-full transition-colors"
            >
              <Minimize2 className="h-5 w-5" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-6 space-y-4 bg-gray-50">
            {chatMessages.map((message) => (
              <div key={message.id} className={`flex ${message.isBot ? 'justify-start' : 'justify-end'}`}>
                <div className={`max-w-xs px-4 py-3 rounded-2xl shadow-sm ${
                  message.isBot 
                    ? 'bg-white text-black border border-gray-200' 
                    : 'bg-gradient-to-r from-black to-gray-800 text-white'
                }`}>
                  <p className="text-sm leading-relaxed">{message.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="p-6 border-t bg-white">
            <div className="flex space-x-3">
              <input
                type="text"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                placeholder="Ask me anything..."
                className="flex-1 border border-gray-300 rounded-full px-4 py-3 focus:outline-none focus:ring-2 focus:ring-black text-sm"
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleChatSubmit(e);
                  }
                }}
              />
              <button
                onClick={handleChatSubmit}
                className="bg-gradient-to-r from-black to-gray-800 text-white p-3 rounded-full hover:shadow-lg transition-all transform hover:scale-105"
              >
                <Send className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Chatbot Toggle Button */}
      {!isChatbotOpen && (
        <button
          onClick={() => setIsChatbotOpen(true)}
          className="fixed bottom-6 right-6 bg-gradient-to-r from-black to-gray-800 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all z-50 transform hover:scale-110"
        >
          <MessageCircle className="h-6 w-6" />
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium animate-pulse">
            1
          </span>
        </button>
      )}
    </div>
  );
};

export default EcommerceInterface;
